import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';
import baseUrl from '../../helpers/baseurl';

export const PdfModal = ({ props, setShowModal, showModal, rowInfo }) => {
    useEffect(() => {
        setFinalPath(rowInfo.replace('/usr/src/app/static/uploads/', ''));
    }, [])

    const [finalPath, setFinalPath] = useState();
    const { className } = props;

    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () => {}

    return (
        <>
            <Modal
                centered
                size='xl'
                toggle={toggle}
                isOpen={showModal}
                className={className}
                onClosed={() => { onClosed() }}
                modalTransition={{ timeout: 100 }}
                backdropTransition={{ timeout: 300 }}
            >
                <div className="ratio ratio-4x3">
                    <iframe title="Visualizador de PDF de la Norma" src={`${baseUrl}norms-library/image/${finalPath}#toolbar=0`} ></iframe>
                </div>
            </Modal>
        </>
    )
}
